import { useState } from "react";
import "./KpiEditModal.css";

export default function KpiEditModal({ label, fieldKey, currentValue, onSave, onClose }) {
    const [inputValue, setInputValue] = useState(currentValue ?? "");

    const handleSave = () => {
        onSave(fieldKey, inputValue);
        onClose();
    };

    return (
        <div className="kpi-modal-backdrop" onClick={onClose}>
            <div className="kpi-modal" onClick={e => e.stopPropagation()}>
                <h3 className="kpi-modal-title">Edit — {label}</h3>
                <input
                    className="kpi-modal-input"
                    type="number"
                    value={inputValue}
                    onChange={e => setInputValue(e.target.value)}
                    autoFocus
                    placeholder="Enter value"
                />
                {/* <div className="kpi-modal-notice">
                    💾 A <strong>kpi_data.json</strong> file will download after saving.
                    Replace <code>public/kpi_data.json</code> with it to make it permanent.
                </div> */}
                <div className="kpi-modal-actions">
                    <button className="kpi-modal-cancel" onClick={onClose}>Cancel</button>
                    <button className="kpi-modal-save" onClick={handleSave}>Save</button>
                </div>
            </div>
        </div>
    );
}